import { defineMessages } from 'react-intl';

export const loginMessages = defineMessages({
    welcomeBack: {
        id: 'login-welcome-back',
        defaultMessage: 'Welcome back',
    },
    loginMessage: {
        id: 'login-message',
        defaultMessage: 'Log in to your SmartPark account',
    },
    loginEmailTip: {
        id: 'login-email-tip',
        defaultMessage: 'Use your email to login',
    },
    loginPasswordTip: {
        id: 'login-password-tip',
        defaultMessage: 'Use your password to login',
    },
    login: {
        id: 'login',
        defaultMessage: 'Login',
    },
});

export const forgotPasswordMessages = defineMessages({
    forgotPassword: {
        id: 'forgot-password',
        defaultMessage: 'Forgot your password?',
    },
    forgotPasswordMessage: {
        id: 'forgot-password-message',
        defaultMessage: 'Get back access to your account in no time',
    },
    forgotPasswordEmailTip: {
        id: 'forgot-password-email-tip',
        defaultMessage: 'Enter your email to reset your password',
    },
    forgotPasswordSuccess: {
        id: 'forgot-password-success',
        defaultMessage: 'Check your email for further instructions',
    },
    forgotPasswordSuccessDetails: {
        id: 'forgot-password-success-details',
        defaultMessage: 'We have sent you an email with instructions on how to reset your password',
    },
});

export const resetPasswordMessages = defineMessages({
    resetPassword: {
        id: 'reset-password',
        defaultMessage: 'Reset password',
    },
    resetPasswordMessage: {
        id: 'reset-password-message',
        defaultMessage: 'Enter your new password',
    },
    resetPasswordPasswordTip: {
        id: 'reset-password-password-tip',
        defaultMessage: '8 characters, 1 lowercase, 1 uppercase, 1 number',
    },
    newPassword: {
        id: 'new-password',
        defaultMessage: 'New password',
    },
    confirmNewPassword: {
        id: 'confirm-new-password',
        defaultMessage: 'Confirm new password',
    },
    resetPasswordSuccess: {
        id: 'reset-password-success',
        defaultMessage: 'Password changed',
    },
    resetPasswordSuccessDetails: {
        id: 'reset-password-success-details',
        defaultMessage:
            'Your password has been successfully changed. You will be automatically redirected to the login page.',
    },
});

export const registerMessages = defineMessages({
    welcomeAboard: {
        id: 'register-welcome-aboard',
        defaultMessage: 'Welcome to SmartPark',
    },
    registerMessage: {
        id: 'register-message',
        defaultMessage: 'Lets get you started',
    },
    registerFirstNameTip: {
        id: 'register-first-name-tip',
        defaultMessage: 'Your name, used for identifying you',
    },
    registerLastNameTip: {
        id: 'register-last-name-tip',
        defaultMessage: 'Your last name, used for identifying you',
    },
    registerEmailTip: {
        id: 'register-email-tip',
        defaultMessage: 'Your email used for logging into the system',
    },
    registerPasswordTip: {
        id: 'register-password-tip',
        defaultMessage: '8 characters, 1 lowercase, 1 uppercase, 1 number',
    },
    registerConfirmPasswordTip: {
        id: 'register-confirm-password-tip',
        defaultMessage: 'Type your password again',
    },
    register: {
        id: 'register',
        defaultMessage: 'Register',
    },
});

export const commonMessages = defineMessages({
    firstName: {
        id: 'firstName',
        defaultMessage: 'First name',
    },
    lastName: {
        id: 'lastName',
        defaultMessage: 'Last name',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    firstNamePlaceholder: {
        id: 'first-name-placeholder',
        defaultMessage: 'First name',
    },
    lastNamePlaceholder: {
        id: 'last-name-placeholder',
        defaultMessage: 'Last name',
    },
    emailPlaceholder: {
        id: 'email-placeholder',
        defaultMessage: 'johndoe@smartpark.com',
    },
    password: {
        id: 'password',
        defaultMessage: 'Password',
    },
    confirmPassword: {
        id: 'confirm-password',
        defaultMessage: 'Confirm password',
    },
    slideshowTitleStatistics: {
        id: 'slideshow-title-statistics',
        defaultMessage: 'Business critical statistics',
    },
    slideshowSubtitleStatistics: {
        id: 'slideshow-subtitle-statistics',
        defaultMessage: 'Discover the power of data with our intelligent statistics and widgets',
    },
});
